import { Navigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

// ----------------------------------------------------------------------

// The Auth0 roles claim is a space-separated string (see nav-vertical.tsx / auth-guard.tsx). The
// agency owner carries the `owner` role; employees do not.
const roleClaimName = 'https://miami-ship/roles';

type Props = {
  children: React.ReactNode;
};

// Owner-only route guard (#59). Mirrors the role-detection used by the dashboard navigation: only
// users whose Auth0 roles claim includes `owner` may reach the wrapped route. Everyone else is
// bounced to the dashboard. This is a UI gate only — the backend `read:billing` policy is the real
// authority. Wrap inside AuthGuard so authentication has already been resolved.
export default function OwnerGuard({ children }: Props) {
  const { user } = useAuth0();
  const roles: string[] = user?.[roleClaimName]?.split(' ') ?? [];
  const isOwner = roles.includes('owner');

  if (!isOwner) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
